module.exports = __webpack_public_path__ + "assets/calendar.99d1d94848928990043827c22c7ea9b0.png";